import { Navbar, Text } from '@resultadosdigitais/tangram-components';
import { Outlet } from 'react-router-dom';

import { Avatar } from './components/avatar';
import { useAgent } from './context/agent';

const Header = () => {
  const agent = useAgent();
  return (
    <Navbar
      style={{
        paddingRight: 'var(--size-spacing-04)',
        paddingLeft: 'var(--size-spacing-04)',
      }}
    >
      <Navbar.Section
        fluid
        unbordered
        style={{ gap: 'var(--size-spacing-03)' }}
      >
        <Avatar size="sm" agent={agent} />
        <Text token={Text.tokens.TEXT_MD_BOLD} truncate>
          {agent.name}
        </Text>
      </Navbar.Section>
    </Navbar>
  );
};

export const Component = () => {
  return (
    <>
      <Header />
      <Outlet />
    </>
  );
};
